// extracted by mini-css-extract-plugin
export default {"information":"information_information__eInmw"};